import { useMemo, useState } from 'react';
import { Select, SelectProps } from '@consta/uikit/Select';
import { Scheme } from '@@/schemes/ts';
import { SCHEMES_INFO_DICTIONARY } from '@@/schemes/dictionaries/schemes.dictionaries';
import { Modal } from 'antd';
import { TabsBar } from '@/modules/common/components/tabs-bar';
import styles from './index.module.sass';
import redArrow from '@@/schemes/icons/red-arrow.svg';
import blueArrow from '@@/schemes/icons/blue-arrow.svg';
import brase from '@@/schemes/icons/brase.svg';
import byOrder from '@@/schemes/images/by-order.jpg';
import byGroup from '@@/schemes/images/by-group.jpg';
import byPair from '@@/schemes/images/by-pair.jpg';

const items = Object.values(Scheme).map((scheme) => ({
  id: scheme,
  label: SCHEMES_INFO_DICTIONARY[scheme as Scheme]?.name,
  value: scheme,
}));

export function SchemeSelect(props: ISchemeSelectProps) {
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const { label, value, onChange, ...rest } = props;
  const currentValue = useMemo(() => items.find((item) => item.id === value), [value]);
  const onChangeLocal: SelectProps['onChange'] = ({ value }) =>
    onChange(value?.id as Scheme);
  
  const tabs = [
    { label: 'последовательная', id: 0, disabled: false}, 
    { label: 'попарная', id: 1, disabled: false}, 
    { label: 'групповая', id: 2, disabled: false}, 
  ];

  return (
    <>
      <Select
        label={label ?? 'Выберите схему'}
        items={items}
        value={currentValue}
        onChange={onChangeLocal}
        {...rest}
      />
      <div style={{ textAlign: 'right' }}>
        <span
          style={{ fontWeight: 600, color: '#409BFF', cursor: 'pointer' }}
          onClick={() => setShowMoreModal(true)}
        >
          подробнее
        </span>
      </div>
      <Modal
        title="шаблоны размещения рукавов:"
        footer={null}
        closable={true}
        open={showMoreModal}
        onCancel={() => setShowMoreModal(false)}
        width={1382}
      >
        <TabsBar activeItem={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
        <div className={styles.suggestionsBar}>
          <SchemeSuggestion label='загрузка рукава' color='#F1898E' iconSrc={redArrow}/>
          <SchemeSuggestion label='выгрузка рукава' color='#409BFF' iconSrc={blueArrow}/>
          <SchemeSuggestion label='начало рукава' color='#F8C4C6' iconSrc={brase}/>
        </div>
        <div className={styles.imageArea}>
          { activeTab === 0 ? <img alt="scheme" src={byOrder}/> : activeTab === 1 ? <img alt="scheme" src={byPair}/> : <img alt="scheme" src={byGroup}/>}
        </div>
      </Modal>
    </>
  );
}

export interface ISchemeSelectProps
  extends Omit<SelectProps, 'items' | 'groups' | 'value' | 'onChange'> {
  value: Scheme;
  onGetMore?: () => {};
  onChange: (scheme: Scheme) => void | Promise<void>;
}

function SchemeSuggestion ({ color, label, iconSrc }: { color: string, label: string, iconSrc: string }) {
  return <div className={styles.schemeSuggestion}>
    <img alt="icon" src={iconSrc}/>
    <span style={{ color  }}>{label}</span>
  </div>
}
